<div class="busqueda-zona-container">
  <!-- Info banner según el contexto: sobre una zona elegida, o sobre un punto
       del mapa cuando no hay nada seleccionado -->
  @if (!infoBannerVehiculosCerrado) {
    @if (contextoZona === 'ubicacion' && hayVehiculo) {
      <app-info-banner
        [title]="'Salidas a la zona'"
        [message]="
          'Detecta las salidas y regresos del vehículo seleccionado a la zona. Para ver todos los vehículos que pasaron por ella, soltá el vehículo.'
        "
        [icon]="'event_repeat'"
        [collapsible]="true"
        (closed)="infoBannerVehiculosCerrado = true"
      ></app-info-banner>
    } @else if (contextoZona === 'ubicacion') {
      <app-info-banner
        [title]="'Vehículos en la zona'"
        [message]="
          'Busca los vehículos que pasaron y/o permanecieron en la zona seleccionada.'
        "
        [icon]="'location_on'"
        [collapsible]="true"
        (closed)="infoBannerVehiculosCerrado = true"
      ></app-info-banner>
    } @else {
      <app-info-banner
        [title]="'Vehículos por dirección'"
        [message]="
          'Busca los vehículos que pasaron por un punto del mapa. Escribí una dirección o dibujá un círculo libre con el botón de al lado, ajustá el radio y el tiempo mínimo de permanencia.'
        "
        [icon]="'pin_drop'"
        [collapsible]="true"
        (closed)="infoBannerVehiculosCerrado = true"
      ></app-info-banner>
    }
  }

  <!-- MODO: VEHÍCULOS POR ZONA -->
  @if (modoBusquedaZona === 'vehiculosPorZona') {
    <div class="form-section">
      <!-- Fecha de búsqueda -->
      <div class="campo-grupo">
        <app-section-title
          icon="event"
          title="Fecha"
          margin="0"
          [divisor]="false"
        ></app-section-title>

        <app-date-range-picker
          [(ngModel)]="range"
          [maxHoras]="24"
          [(modoAvanzado)]="modoAvanzadoFecha"
        />
      </div>

      <!-- Centro de la búsqueda. Con una zona seleccionada se usa esa: el
           selector sobra porque la zona se elige clickeándola en el mapa. -->
      @if (contextoZona === 'sin-seleccion') {
        <div class="campo-grupo">
          <app-section-title
            icon="place"
            title="Dirección (opcional)"
            margin="0"
            [divisor]="false"
          ></app-section-title>

          <div class="direccion-row">
            <app-autocomplete-direccion
              [direccion]="direccion"
              (geoJSONChange)="direccionAutocompleteChange($event)"
              (direccionChange)="direccion = $event"
              class="direccion-field"
            ></app-autocomplete-direccion>

            <button
              irxBotonIcono="borde"
              tono="primario"
              type="button"
              class="boton-dibujar"
              (click)="dibujarEnMapa()"
              [tooltip]="
                circuloDeBusqueda?.coordinates
                  ? 'Editar el círculo dibujado en el mapa'
                  : 'Dibujar un círculo en el mapa'
              "
            >
              <mat-icon>
                {{ circuloDeBusqueda?.coordinates ? 'edit' : 'gesture' }}
              </mat-icon>
            </button>
          </div>
        </div>
      }

      <!-- Radio y permanencia: los dos acotan el mismo resultado, van juntos.
           El radio sólo aplica al círculo; sobre una zona manda su polígono. -->
      @if (tipoSeleccionado !== 'Visitas') {
        <div class="campos-row">
          @if (tipoSeleccionado === 'Dirección') {
            <div class="campo-grupo">
              <app-section-title
                title="Radio de búsqueda"
                margin="0"
                [divisor]="false"
              ></app-section-title>

              <mat-form-field appearance="outline" class="radio-field">
                <mat-icon matPrefix>adjust</mat-icon>
                <input
                  type="number"
                  step="1"
                  matInput
                  [formControl]="radio"
                  placeholder="Ej: 100"
                  (change)="onRadioChange()"
                  (blur)="onRadioChange()"
                />
                <span matSuffix class="radio-suffix">metros</span>
              </mat-form-field>
            </div>
          }

          <div class="campo-grupo">
            <app-section-title
              title="Tiempo en zona"
              margin="0"
              [divisor]="false"
            ></app-section-title>

            <mat-form-field appearance="outline" class="tiempo-field">
              <mat-icon matPrefix>timer</mat-icon>
              <input
                type="number"
                matInput
                [formControl]="minutosMinimos"
                placeholder="Ej: 5"
              />
              <span matSuffix class="tiempo-suffix">minutos</span>
            </mat-form-field>
          </div>
        </div>
      }

      <!-- Gap entre reportes (solo para Visitas/Salidas) -->
      @if (tipoSeleccionado === 'Visitas') {
        <div class="campo-grupo">
          <app-section-title
            title="Gap entre salidas"
            margin="0"
            [divisor]="false"
          ></app-section-title>

          <mat-form-field appearance="outline" class="tiempo-field">
            <mat-icon matPrefix>timer_off</mat-icon>
            <input
              type="number"
              matInput
              [formControl]="gapMin"
              placeholder="Ej: 5"
              min="1"
              max="60"
            />
            <span matSuffix class="tiempo-suffix">minutos</span>
            <mat-hint>Tiempo afuera para considerar una nueva salida</mat-hint>
          </mat-form-field>
        </div>
      }
    </div>

    @if (tipoSeleccionado === 'Visitas' && mostrarMensajeVehiculoRequerido) {
      <app-hint
        [color]="'red'"
        [icon]="'warning'"
        [message]="'Seleccioná un vehículo en el mapa antes de buscar salidas.'"
      ></app-hint>
    }

    @if (mostrarMensajeSinResultadosVisitas) {
      <app-hint
        [color]="'red'"
        [icon]="'error'"
        [message]="
          'No se detectaron salidas del vehículo a esta ubicación en el rango.'
        "
      ></app-hint>
    }

    @if (tipoSeleccionado === 'Visitas' && visitas?.length > 0) {
      <div class="resultados-section">
        <app-section-title
          icon="list"
          title="Salidas detectadas"
          margin="0"
          [divisor]="false"
        ></app-section-title>

        <div class="resultados-header">
          <span class="contador-resultados">
            {{ visitas.length }} salida{{ visitas.length !== 1 ? 's' : '' }}
          </span>
        </div>

        <div class="visitas-container">
          @for (visita of visitas; track visita.entrada) {
            <div
              class="visita-card irx-clickeable"
              role="button"
              tabindex="0"
              [class.selected]="visitaSeleccionada?.entrada === visita.entrada"
              (click)="seleccionarVisita(visita)"
              (keydown.enter)="seleccionarVisita(visita)"
            >
              <div class="visita-info">
                <mat-icon class="visita-icon">event_repeat</mat-icon>
                <div class="visita-datos">
                  <span class="visita-horario">
                    @if (visita.entrada === visita.salida) {
                      {{ visita.entrada | date: 'HH:mm' }}
                    } @else {
                      <mat-icon class="horario-icon">login</mat-icon>
                      {{ visita.entrada | date: 'HH:mm' }}
                      <mat-icon class="horario-icon separador">
                        arrow_forward
                      </mat-icon>
                      <mat-icon class="horario-icon">logout</mat-icon>
                      {{ visita.salida | date: 'HH:mm' }}
                    }
                    @if (visita.permanenciaSegundos) {
                      <span class="duracion-badge">
                        {{ formatearDuracion(visita.permanenciaSegundos) }}
                      </span>
                    }
                  </span>
                  <div class="visita-badges">
                    @if (visita.yaEstabaAlInicio) {
                      <span class="badge badge-info">Ya en zona al inicio</span>
                    }
                    @if (visita.seguiaAlFinal) {
                      <span class="badge badge-info">
                        Seguía en zona al cierre
                      </span>
                    }
                  </div>
                  @if (
                    visitaSeleccionada?.entrada === visita.entrada &&
                    vueltaResumen
                  ) {
                    <div class="vuelta-resumen">
                      <span class="vuelta-label">Vuelta:</span>
                      {{ vueltaResumen.distanciaKm | number: '1.0-2' }} km · máx
                      {{ vueltaResumen.maxSpeed | number: '1.0-0' }} km/h · prom
                      {{ vueltaResumen.avgSpeed | number: '1.0-0' }} km/h
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (mostrarMensajeSinResultadosVehiculos) {
      <app-hint
        [color]="'red'"
        [icon]="'error'"
        [message]="
          'No se encontraron vehículos en la zona especificada para los criterios de búsqueda.'
        "
      ></app-hint>
    }

    <!-- Resultados de búsqueda (vehículos por zona) -->
    @if (interaccionesFiltradas?.length > 0) {
      <div class="resultados-section">
        <app-section-title
          icon="list"
          title="Vehículos encontrados"
          margin="0"
          [divisor]="false"
        ></app-section-title>

        <div class="resultados-header">
          <span class="contador-resultados">
            {{ vehiculosEnZona.length }} vehículo{{
              vehiculosEnZona.length !== 1 ? 's' : ''
            }}
            @if (interaccionesFiltradas.length !== vehiculosEnZona.length) {
              · {{ interaccionesFiltradas.length }} pasos
            }
          </span>
          <button
            irxBotonIcono
            tono="primario"
            (click)="exportarVehiculos()"
            tooltip="Exportar vehículos a Excel"
            class="exportar-btn"
          >
            <mat-icon>file_download</mat-icon>
          </button>
        </div>

        <!-- Una tarjeta por vehículo: adentro, cada vez que entró a la zona -->
        <div class="vehiculos-container">
          @for (element of vehiculosEnZona; track element.idVehiculo) {
            <div class="vehiculo-card">
              <div class="vehiculo-info">
                <mat-icon class="vehiculo-icon">directions_car</mat-icon>
                <div class="vehiculo-datos">
                  <span class="vehiculo-nombre">
                    {{ element.vehiculo.identificacion }}
                    @if (element.pasos.length > 1) {
                      <span class="pasos-badge">
                        {{ element.pasos.length }} pasos
                      </span>
                    }
                  </span>

                  @for (paso of element.pasos; track paso.entro) {
                    <span class="vehiculo-horario">
                      @if (paso.entro === paso.salio) {
                        {{ paso.entro | date: 'HH:mm' }}
                      } @else {
                        <mat-icon class="horario-icon">login</mat-icon>
                        {{ paso.entro | date: 'HH:mm' }}
                        <mat-icon class="horario-icon separador">
                          arrow_forward
                        </mat-icon>
                        <mat-icon class="horario-icon">logout</mat-icon>
                        {{ paso.salio | date: 'HH:mm' }}
                      }
                      @if (paso.duracionMinutos) {
                        <span class="duracion-badge">
                          {{ paso.duracionMinutos }} min
                        </span>
                      }
                    </span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }

  <!-- Loading indicator -->
  @if (buscando) {
    <div class="loading-container">
      <mat-card class="loading-card">
        <mat-card-content class="loading-content">
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
            diameter="40"
          ></mat-progress-spinner>
          <p class="loading-text">
            @if (modoBusquedaZona === 'vehiculosPorZona') {
              @if (tipoSeleccionado === 'Visitas') {
                Detectando salidas...
              } @else {
                Buscando vehículos en la zona...
              }
            } @else {
              Buscando zonas visitadas...
            }
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  }

  <!-- Sección de acciones -->
  <div class="acciones-section">
    <div class="botones-container">
      <app-button
        matType="mat-fab"
        color="primary"
        (click)="buscar()"
        [icon]="'search'"
        [tooltip]="
          modoBusquedaZona === 'vehiculosPorZona'
            ? 'Buscar vehículos en la zona'
            : 'Buscar zonas del vehículo'
        "
        class="boton-buscar"
      ></app-button>

      <button
        irxBotonIcono="borde"
        tono="primario"
        tamano="campo"
        (click)="resetear()"
        tooltip="Limpiar búsqueda"
        type="button"
        class="boton-resetear"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</div>
